import Localizr from '../utils/Localizr';
import Preloader from '../utils/Preloader';

import './fury.scss';
import DisplayList from '../app/components/DisplayList';

class Fury {
  constructor() {
    this.layout();
    // initButtons();
  }

  layout() {
    document.querySelector('#shell').appendChild(Localizr.template(Preloader.getFile('fury-template'), {}));

    Localizr.parseObjectList(settings.sections.fury.items);

    DisplayList.create(
        '<img src="{{image}}" alt="{{alt}}">',
        settings.sections.fury.gallery.filter((img) => img.visible),
        document.querySelector('.fury-thumbs')
    );
  }

  initButtons() {}

  preenter() {}

  enter() {
    // trackPageView('About');
    return new Promise((resolve, reject) => {
      resolve();
    });
  }

  onEnterStart() {
    resizer.force();
  }

  onEnterComplete() {
    SITE.utils.sequencer.next();
  }

  exit() {
    return new Promise((resolve, reject) => {
      resolve();
    });
  }

  postExit() {}

  onResize(sizes) {}
}

export default Fury;
